import { __decorate, __extends } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';

var ImagePopup =
/** @class */
function (_super) {
  __extends(ImagePopup, _super);

  function ImagePopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.value = false;
    return _this;
  }

  __decorate([Prop({
    type: String
  })], ImagePopup.prototype, "src", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], ImagePopup.prototype, "imageClass", void 0);

  ImagePopup = __decorate([Component({
    name: 'ImagePopup'
  })], ImagePopup);
  return ImagePopup;
}(Vue);

export default ImagePopup;